import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const appVersion = process.env['REACT_APP_VERSION'] ?? '';
const env = process.env['REACT_APP_ENV'] ?? '';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    version: {
      position: 'fixed',
      bottom: 0,
      right: 0,
    },
  }),
);

export function VersionNumber() {
  const classes = useStyles();
  if (env === 'prod') return null;
  return (
    <div className={classes.version}>{appVersion}</div>
  );
}